import Highlight from 'reveal.js/plugin/highlight/highlight';
import Notes from "reveal.js/plugin/notes/notes";
import RevealMarkdown from "reveal.js/plugin/markdown/markdown";
// Import theme
import 'reveal.js/dist/theme/black.css';

// Import CSS for plugins
import 'reveal.js/plugin/highlight/monokai.css'; 

export default {
    // App Config
    app: {},
    // Reveal Config
    revealConfig: {
        plugins: [Highlight, Notes, RevealMarkdown],
        hash: true,
    },
};

